<template lang="pug">
	.element-effects
		.header-container(v-if="element")
			.default-header
				.name(v-if="animations.length || emitters.length")
					span(v-if="element.type === 'global'") Global animations
					span(v-else-if="element.type === 'root-container'") Scene animations
					span(v-else) Element animations
				.name(v-else)
					span(v-if="element.type === 'global'") There are no global animations
					span(v-else-if="element.type === 'root-container'") There are no scene animations
					span(v-else) This element has no animations
				.revert-effects
					.option.restore(v-if="isTemplateElement(element) && isTemplateAnimationsChanged()" v-on:click="restoreAnimation(animation)")
						.fa.fa-rotate-left
		.effects-list
			.effect-container(v-for="animation in animations" :class="{active: Animation.animationPlaying[animation.id]}")
				.effect-header
					.effect-title {{animation.title}}
					.effect-controls
						.control.play(@click="Animation.animationPlaying[animation.id] ? stopAnimation(animation) : playAnimation(animation)" title="Play animation")
							i.fa(:class="{'fa-play-circle': !Animation.animationPlaying[animation.id], 'fa-stop-circle': Animation.animationPlaying[animation.id]}")
						.control.edit(v-on:click="editAnimation(animation)")
							.fa.fa-gears
					.options
						.option.restore(v-if="isTemplateAnimation(animation) && isTemplateAnimationChanged(animation)" v-on:click="restoreAnimation(animation)")
							.fa.fa-rotate-left
						.option.remove(v-on:click="removeAnimation(animation, $event)")
							.fa.fa-remove
			.effect-container(v-for="emitter in emitters" :class="{active: Emitter.emitterPlaying[emitter.id]}")
				.effect-header
					.effect-title {{emitter.title}}
					.effect-controls
						.control.play(@click="Emitter.emitterPlaying[emitter.id] ? stopEmitter(emitter) : playEmitter(emitter)" title="Play emitter")
							i.fa(:class="{'fa-play-circle': !Emitter.emitterPlaying[emitter.id], 'fa-stop-circle': Emitter.emitterPlaying[emitter.id]}")
						.control.edit(v-on:click="editEmitter(emitter)")
							.fa.fa-gears
					.options
						.option.restore(v-if="isTemplateEmitter(emitter) && isTemplateEmitterChanged(emitter)" v-on:click="restoreEmitter(emitter)")
							.fa.fa-rotate-left
						.option.remove(v-on:click="removeEmitter(emitter, $event)")
							.fa.fa-remove
		.effects-controls(v-if="element?.type !== 'global' && element?.type !== 'root-container'")
			.dropdown-element-effect(@click="openEffectAddMenu($event)")
				.value Add animation
				.drop-icon.fa.fa-caret-down
</template>

<script>

	import Screen 							from './../../mixins/screen'

	import { Version }						from './../../services/Version'
	import { Elements }						from './../../services/Elements'
	import { Animation }					from './../../services/Animation'
	import { Emitter }						from './../../services/Emitter'

	export default {
		name: 'EditorElementInfoEffects',
		mixins: [Screen],
		screen: {
			updateOn: [
				"Selected Version Switched",
				"Selected Screen Switched",
				"Selected Element Switched",
				"Selected Element Animation Added",
				"Selected Element Animation Changed",
				"Selected Element Animation Removed",
				"Selected Element Emitter Added",
				"Selected Element Emitter Changed",
				"Selected Element Emitter Removed",
				"Settings Tab Changed",
				"Aside State Changed",
				"Selected Element Animation Playing Changed",
				"Selected Element Emitter Playing Changed"
			],
			events: {
			}
		},
		props: [],
		data() {

			this.Animation = Animation;
			this.Emitter = Emitter;

			this.element = null;
			this.animations = [];
			this.emitters = [];

			return {
				showed: true
			};

		},
		mounted() {

		},
		methods: {
			collectData() {

				this.version = Version.SelectedVersion;
				this.element = Elements.SelectedElement;
				this.animations = Animation.getAnimations(this.version?.id, this.element?.["screen_codename"], this.element?.codename);
				this.emitters = Emitter.getEmitters(this.version?.id, this.element?.["screen_codename"], this.element?.codename);

			},
			editAnimation(animation) {

				Broadcast.call("Show Animation Settings", [animation]);

			},
			playAnimation(animation) {

				Broadcast.call("Send To iFrame", [{
					PlayAnimation: {
						screenCodename: this.element['screen_codename'],
						elementCodename: this.element.codename,
						animationCodename: animation.codename
					}
				}]);

				Animation.animationPlaying[animation.id] = true;

				this.update();

			},
			stopAnimation(animation) {

				Broadcast.call("Send To iFrame", [{
					StopAnimation: {
						screenCodename: this.element['screen_codename'],
						elementCodename: this.element.codename,
						animationCodename: animation.codename
					}
				}]);

				Animation.animationPlaying[animation.id] = false;

				this.update();

			},
			isTemplateElement(element) {

				return !!element.options.elementTemplateId;

			},
			isTemplateAnimation(animation) {

				return !!animation.options.animationTemplateId;

			},
			isTemplateAnimationsChanged() {

				let result = false;

				_.each(this.animations, animation => {

					if (this.isTemplateAnimationChanged(animation)) result = true;

				});

				return result;

			},
			isTemplateAnimationChanged(animation) {

				// TODO: как определить что анимация изменилась? Проще всего не сравнивать показатели а ставить в БД галочку
				//  или сравнивать json строки всех шагов? или _.isEqual?
				return false;

			},
			restoreAnimation(animation) {

			},
			removeAnimation(animation, e) {

				Broadcast.call('Show Confirm', [{
					caption: 'Remove animation',
					message: `Are you sure you want to remove animation "${animation.title}" from element "${Elements.SelectedElement.codename}"?`,
					confirmButtonText: '&nbsp;&nbsp;Remove animation',
					confirmButtonIcon: 'fa-remove',
					forceConfirm: e.shiftKey,
					confirmCallback: () => {
						Server.sendToSocket({
							RemoveAnimation: {
								versionId: Version.SelectedVersion.id,
								animationId: animation.id
							}
						});
					}
				}]);

			},
			editEmitter(emitter) {

				Broadcast.call("Show Emitter Settings", [emitter]);

			},
			playEmitter(emitter) {

				Broadcast.call("Send To iFrame", [{
					PlayEmitter: {
						screenCodename: this.element['screen_codename'],
						elementCodename: this.element.codename,
						emitterCodename: emitter.codename
					}
				}]);

				Emitter.emitterPlaying[emitter.id] = true;

				this.update();

			},
			stopEmitter(emitter) {

				Broadcast.call("Send To iFrame", [{
					StopEmitter: {
						screenCodename: this.element['screen_codename'],
						elementCodename: this.element.codename,
						emitterCodename: emitter.codename
					}
				}]);

				Emitter.emitterPlaying[emitter.id] = false;

				this.update();

			},
			isTemplateElement(element) {

				return !!element.options.elementTemplateId;

			},
			isTemplateEmitter(emitter) {

				return !!emitter.options.emitterTemplateId;

			},
			isTemplateEmittersChanged() {

				let result = false;

				_.each(this.emitters, emitter => {

					if (this.isTemplateEmitterChanged(emitter)) result = true;

				});

				return result;

			},
			isTemplateEmitterChanged(emitter) {

				// TODO: как определить что анимация изменилась? Проще всего не сравнивать показатели а ставить в БД галочку
				//  или сравнивать json строки всех шагов? или _.isEqual?
				return false;

			},
			restoreEmitter(emitter) {

			},
			removeEmitter(emitter, e) {

				Broadcast.call('Show Confirm', [{
					caption: 'Remove emitter',
					message: `Are you sure you want to remove emitter "${emitter.title}" from element "${Elements.SelectedElement.codename}"?`,
					confirmButtonText: '&nbsp;&nbsp;Remove emitter',
					confirmButtonIcon: 'fa-remove',
					forceConfirm: e.shiftKey,
					confirmCallback: () => {
						Server.sendToSocket({
							RemoveEmitter: {
								versionId: Version.SelectedVersion.id,
								emitterId: emitter.id
							}
						});
					}
				}]);

			},
			openEffectAddMenu(e) {

				Broadcast.call("Show EditorElementInfoEffectsAdd", [e.target.closest('.dropdown-element-effect'), this.element]);

			}
		}

	}
</script>

<style lang="sass">

	.element-effects
		background-color: #343b41
		color: #f3f4f5

		.header-container
			display: flex
			flex-direction: row
			flex-wrap: nowrap
			align-items: center
			height: 46px
			padding: 5px
			border-bottom: 1px solid #23282c
			cursor: default

			.default-header
				display: flex
				flex-direction: row
				flex-wrap: nowrap
				align-items: center
				justify-content: center
				width: 100%

				.name
					color: #73818f
					display: flex
					padding: 5px

		.effects-list

			.effect-container
				display: flex
				flex-direction: column
				flex-wrap: nowrap
				justify-content: space-between
				border-bottom: 1px solid #2e3235
				padding-left: 0.5rem
				padding-right: 0.5rem

				.effect-header
					display: flex
					flex-direction: row
					flex-wrap: nowrap
					width: 100%
					align-items: center

					.effect-title
						display: flex
						align-items: center
						justify-content: left
						width: 100px
						color: #73818f
						font-size: 14px
						cursor: default
						user-select: none
						white-space: nowrap

					.effect-controls
						display: flex
						flex-direction: row
						cursor: pointer
						transition: 0.2s
						padding: 2px 0px
						font-size: 18px
						color: #fff
						margin-left: auto

						.control
							color: rgba(255, 255, 255, 0.25)
							margin-right: 12px

						.control:hover

							.fa
								color: #20a8d8

					.options
						display: flex
						flex-direction: row
						flex-wrap: nowrap
						align-items: center
						justify-content: right
						width: 25px

						.option
							width: 15px
							height: 15px
							border: 1px solid rgba(255, 255, 255, 0.09)
							background-color: rgba(255, 255, 255, 0.05)
							border-radius: 0.1rem
							cursor: pointer
							margin-right: 2px

							&.remove, &.restore
								border: none
								background: transparent
								font-size: 14px
								position: relative

								.fa
									position: absolute
									left: 2px
									top: 2px
									color: rgba(255, 255, 255, 0.15)

								&:hover

									.fa
										color: #20a8d8

							&.remove
								margin-top: -2px

							&:last-child
								margin-right: 0

			.effect-container.active

				.effect-header

					.effect-title
						color: var(--green)

		.effects-controls
			display: flex
			flex-direction: row
			justify-content: left
			padding-top: 10px
			border-top: 1px solid #2e3235

			.dropdown-element-effect
				position: relative
				border: 1px solid rgba(255, 255, 255, 0.1)
				border-radius: 0.25rem
				background: rgba(255, 255, 255, 0.05) no-repeat
				background-position-x: right 0.75rem
				background-position-y: calc(50% - 1px)
				background-size: 8px 10px
				padding-top: 0.25rem
				padding-bottom: 0.25rem
				padding-right: 2rem
				padding-left: 0.5rem
				color: rgba(255, 255, 255, 0.5)
				cursor: pointer
				font-size: 0.765625rem
				margin-left: 5px

				&:hover
					border: 1px solid rgba(255, 255, 255, 0.3)
					background: rgba(255, 255, 255, 0.1) no-repeat

				.value
					max-width: 125px
					overflow: hidden
					text-overflow: ellipsis
					white-space: nowrap

				.drop-icon
					position: absolute
					right: 13px
					top: 8px
					color: rgba(255, 255, 255, 0.50)

</style>
